var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "propertys-list w-100" },
    [
      _vm._l(_vm.sortedList, function (props) {
        return [
          _vm._l(props.properties, function (currentprop) {
            return [
              currentprop.id != 300
                ? [
                    currentprop.values.value
                      ? [
                          currentprop.values.value.length > 30
                            ? [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex-fill d-flex w-100 py-2 cursor",
                                    attrs: {
                                      "data-toggle": "collapse",
                                      id: "heading_" + currentprop.id,
                                      "data-target":
                                        "#collapse_" + currentprop.id,
                                      "aria-expanded": "false",
                                      "aria-controls":
                                        "collapse_" + currentprop.id,
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "w-50 font-weight-bold" },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(currentprop.names.name) +
                                            "\n                            "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._m(0, true),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "py-2 w-100 collapse",
                                  attrs: {
                                    id: "collapse_" + currentprop.id,
                                    "data-parent": ".single-character",
                                  },
                                  domProps: {
                                    innerHTML: _vm._s(currentprop.values.value),
                                  },
                                }),
                              ]
                            : [
                                _c(
                                  "div",
                                  {
                                    staticClass: "flex-fill d-flex w-100 py-2",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "w-50 font-weight-bold" },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(currentprop.names.name) +
                                            "\n                            "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    currentprop.values.value
                                      ? [
                                          _c("div", {
                                            staticClass: "w-50",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                currentprop.values.value
                                              ),
                                            },
                                          }),
                                        ]
                                      : [
                                          _c("div", { staticClass: "w-50" }, [
                                            _vm._v(" "),
                                          ]),
                                        ],
                                  ],
                                  2
                                ),
                              ],
                        ]
                      : _vm._e(),
                  ]
                : _vm._e(),
            ]
          }),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-50 text-right" }, [
      _c("i", { staticClass: "fa fa-plus" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }